import React, {ReactElement} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';

import Button, {ButtonVariant} from '../Button/Button';
import {ReactComponent as LogoutIcon} from '../../../../images/icons/logout.svg';
import {useIdentityContext} from '../../../../RootProvider/IdentityContext';
import {MixpanelTrackEvent} from '../../../../analytics/tracking/tracking';

interface Props {
  buttonVariant?: ButtonVariant;
  showIcon?: boolean;
  className?: string;
  iconClassName?: string;
}

function LogoutButton({
  buttonVariant = ButtonVariant.PRIMARY_OUTLINE,
  showIcon,
  className = '',
  iconClassName = '',
}: Props): ReactElement {
  const {logout} = useIdentityContext();
  const {formatMessage} = useIntl();

  return (
    <Button
      ariaLabel={formatMessage({id: 'phoenix.logout.button.text'})}
      id="logout"
      type="button"
      onClick={logout}
      mixpanelEvent={MixpanelTrackEvent.userLogout}
      variant={buttonVariant}
      className={className}
    >
      {showIcon && <LogoutIcon className={iconClassName} />}
      <FormattedMessage id="phoenix.logout.button.text" />
    </Button>
  );
}

export default LogoutButton;
